import React from 'react';
import { Hero } from '../components/Hero';
import { SolutionSection } from '../components/SolutionSection';
import { ProductContents } from '../components/ProductContents';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold-500/30" data-id="element-319">
      <Hero data-id="element-320" />
      <SolutionSection data-id="element-321" />
      <ProductContents data-id="element-322" />
      <BonusSection data-id="element-323" />
      <PricingSection data-id="element-324" />
      <TestimonialsSection data-id="element-325" />
      <FinalCTA data-id="element-326" />
      <SocialProofPopup data-id="element-327" />
    </div>;
}